import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c34c9c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card reports--room" }
const _hoisted_2 = { class: "btn-group-vertical" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "h3 pt-1 ml-2 mr-2 d-inline-block float-right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "h5 float-right text-muted mt-2 mr-2" }
const _hoisted_13 = {
  key: 0,
  class: "card-body"
}

import { computed, ref, inject, provide, getCurrentInstance } from 'vue';
import store from '@/store';
import { useToast } from "vue-toastification";
import { Report, Room } from "@/models";
import { ReportsState } from '@/store/reports/types';
import { emitEvent } from '@/eventBus';
import ContentEditable from '../ContentEditable.vue';
import ReportRoomSection from './Section.vue';

// Props with type annotation

export default /*#__PURE__*/_defineComponent({
  __name: 'Room',
  props: {
    index: {},
    room: {},
    toggle: { type: Boolean },
    opened: { type: Boolean }
  },
  emits: ['showBody'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

provide('roomIndex', props.index);

const instance = getCurrentInstance();

// Using `inject` to replace `actProperty`
const actProperty: any = inject('actProperty');

// State and actions from Vuex store
const reportsState = computed(() => store.state.reports as ReportsState);

const emit = __emit

// Converted methods to use composition API
const removeFromRooms = async (payload: { roomIndex: number }) => {
  await store.dispatch('reports/removeFromRooms', payload);
};

const setReportDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('reports/setReportDeep', payload);
};

const moveRoomDownAction = async (uuid: string) => {
  await store.dispatch('reports/moveRoomDown', uuid);
};

const moveRoomUpAction = async (uuid: string) => {
  await store.dispatch('reports/moveRoomUp', uuid);
};

// Mutation from Vuex store
const setCurrentRoom = (room: Room) => {
  store.commit('reports/setCurrentRoom', room);
};

// Reactive references for local state
const showBody = ref<boolean>(true);

// Computed getters based on props
const _index = computed(() => props.index);
const _room = computed(() => props.room);
const _toggle = computed(() => props.toggle);
const _opened = computed(() => props.opened);
const report = computed(() => reportsState.value.current);

// Methods converted to composition API
const toggleShowBody = () => {
  setCurrentRoom(_room.value);
  if (_toggle.value) {
    showBody.value = !_opened.value;
    emit("showBody", _index.value, showBody.value);
  }
};

const remove = async () => {
  actProperty
    .confirmPrompt()
    .then(() =>
      removeFromRooms({
        roomIndex: _index.value,
      })
    )
    .then(() => instance?.proxy?.$forceUpdate());
};

const moveRoomDown = async (uuid: string) => {
  moveRoomDownAction(uuid).then(() => emitEvent("collapseAll"));
};

const moveRoomUp = async (uuid: string) => {
  moveRoomUpAction(uuid).then(() => emitEvent("collapseAll"));
};

// Watchers or other composition functions (if needed) can be defined here

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-header", { 'toggle-body': _toggle.value }])
    }, [
      _createElementVNode("h2", {
        class: "mb-0",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (toggleShowBody()), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary order-arrows",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (moveRoomUp(_room.value._uuid)), ["stop"])),
            disabled: _index.value == 0
          }, _hoisted_5, 8, _hoisted_3),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary order-arrows",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (moveRoomDown(_room.value._uuid)), ["stop"])),
            disabled: _index.value == report.value.rooms.length - 1
          }, _hoisted_8, 8, _hoisted_6)
        ]),
        _createVNode(ContentEditable, {
          content: _room.value.name,
          class: "h3 ml-2 mr-2 d-inline-block",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          onUpdate: _cache[3] || (_cache[3] = ($event: any) => (
            setReportDeep({
              path: `rooms[${_index.value}].name`,
              data: $event,
            })
          ))
        }, null, 8, ["content"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (remove())),
            class: "btn btn-sm btn-outline-danger mt-1 float-right"
          }, _hoisted_11),
          _createElementVNode("small", _hoisted_12, _toDisplayString(_room.value.type), 1)
        ])
      ])
    ], 2),
    (_opened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_room.value.sections, (section, $index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: section._uuid
            }, [
              (section.types.length)
                ? (_openBlock(), _createBlock(ReportRoomSection, {
                    key: 0,
                    section: section,
                    index: $index
                  }, null, 8, ["section", "index"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})